import { FunctionComponent } from 'react'
import { ClientOnlyPortal } from '@components/ClientOnly'
import useTooltip from '@/hooks/useTooltip'
import Tooltip from '.'
import { ROOT_EMEMENT_ID } from './settings'

const TooltipProvider: FunctionComponent = () => {
  const { queue: tooltipConfigs } = useTooltip()

  return (
    <ClientOnlyPortal selector={ROOT_EMEMENT_ID}>
      {tooltipConfigs.map((config) => {
        const { id, options } = config
        return <Tooltip key={id} id={id} {...options} />
      })}
    </ClientOnlyPortal>
  )
}

export default TooltipProvider
